<template>
	<vs-prompt
		:active.sync="activeProp"
    :buttons-hidden="true"
		:title="$t('confirmAction')"
		:cancel-text="$t('refuse')"
		button-cancel="filled"
		color="warning"
		class="marginality-popup"
		@cancel="close"
		@close="close"
		@accept="confirm"
	>
		<div class="con-exemple-prompt">
			<div class="content">
				<p>{{ $t("orderPriceIncorrectWarning") }}</p>
			</div>

			<div class="flex justify-center mt-8">
				<vs-button class="mr-4" color="warning" @click="confirm">{{
					$t("confirm")
				}}</vs-button>

				<vs-button color="#9a9a9a" type="flat" @click="close">{{
					$t("cancel")
				}}</vs-button>
			</div>
		</div>
	</vs-prompt>
</template>

<script>
export default {
	name: "OrderPriceIncorrectModal",
	props: {
		active: { default: false, type: Boolean }
	},
	computed: {
		activeProp: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
				return this.active;
			}
		}
	},
	methods: {
		confirm() {
			this.$emit("confirm");
			this.activeProp = false;
		},
		close() {
			this.activeProp = false;
			this.$emit("cancel");
		}
	}
};
</script>

<style lang="scss">
.marginality-popup {
  &.con-vs-dialog {
    z-index: 54000;
  }
	.vs-dialog {
		max-width: 350px;
	}
}
</style>
